module.exports = __webpack_public_path__ + "img/capa2.d26a445f.webp";